import React from 'react';
import { Image, ImageProps } from 'react-native';
import { fixAvatarUrl } from '@/utils/avatarUrl';

/**
 * Drop-in replacement for the RN <Image> that stream-chat-expo renders
 * (passed as `ImageComponent` on <Chat> in [app/_layout.native.tsx]), so every
 * SDK-rendered avatar — channel list, message list — gets the ui-avatars
 * PNG pin from [utils/avatarUrl.ts].
 */
export function ChatImage({ source, ...rest }: ImageProps) {
    let fixedSource = source;
    if (source && typeof source === 'object' && !Array.isArray(source) && source.uri) {
        const uri = fixAvatarUrl(source.uri);
        if (uri !== source.uri) {
            fixedSource = { ...source, uri };
        }
    }
    return <Image {...rest} source={fixedSource} />;
}
